/* ============================================================
   MASTER CERAMISTA — CARRUSEL DE TESTIMONIOS
   assets/mc-artesanal.js  ·  v5
   ------------------------------------------------------------
   v2 CORRIGE v1: buscaba los slides dentro de ".section", pero
   en este tema los bloques cuelgan de ".section-content-wrapper".
   Por eso el carrusel nunca se armaba. Ahora busca el contenedor
   real de los .group-block, sea cual sea.

   Solo toca las secciones de testimonios. No toca carrito,
   checkout, formularios ni la app de cursos.
   ============================================================ */
(function () {
  'use strict';

  var SECCIONES = ['__section_Lb6RF4', '__section_TU9Fac'];
  var INTERVALO = 5000;

  /* Busca el elemento que contiene directamente los .group-block */
  function encontrarPista(seccion) {
    var candidatos = seccion.querySelectorAll('.section-content-wrapper, .section, .group-block-content');
    for (var i = 0; i < candidatos.length; i++) {
      var hijos = candidatos[i].children;
      var n = 0;
      for (var j = 0; j < hijos.length; j++) {
        if (hijos[j].classList.contains('group-block')) n++;
      }
      if (n >= 2) return candidatos[i];
    }
    // Último recurso: el padre común del primer .group-block
    var primero = seccion.querySelector('.group-block');
    return primero ? primero.parentElement : null;
  }

  function armar(seccion) {
    var pista = encontrarPista(seccion);
    if (!pista || pista.dataset.mcCarrusel === 'listo') return;

    var slides = [];
    for (var i = 0; i < pista.children.length; i++) {
      if (pista.children[i].classList.contains('group-block')) slides.push(pista.children[i]);
    }
    if (slides.length < 2) return;

    pista.dataset.mcCarrusel = 'listo';
    pista.classList.add('mc-carrusel');

    var puntos = document.createElement('div');
    puntos.className = 'mc-carrusel__puntos';

    slides.forEach(function (slide, i) {
      slide.classList.add('mc-carrusel__slide');
      var p = document.createElement('button');
      p.type = 'button';
      p.className = 'mc-carrusel__punto';
      p.setAttribute('aria-label', 'Testimonio ' + (i + 1));
      p.addEventListener('click', function () { ir(i, true); });
      puntos.appendChild(p);
    });
    pista.parentNode.insertBefore(puntos, pista.nextSibling);

    var actual = 0, timer = null, pausado = false;

    function pintar() {
      for (var i = 0; i < puntos.children.length; i++) {
        puntos.children[i].classList.toggle('is-activo', i === actual);
      }
    }

    function ir(i, manual) {
      actual = (i + slides.length) % slides.length;
      pista.scrollTo({
        left: slides[actual].offsetLeft - pista.offsetLeft,
        behavior: 'smooth'
      });
      pintar();
      if (manual) { clearInterval(timer); timer = null; arrancar(); }
    }

    function arrancar() {
      if (timer) return;
      timer = setInterval(function () {
        if (!pausado && !document.hidden) ir(actual + 1);
      }, INTERVALO);
    }

    ['mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
      pista.addEventListener(ev, function () { pausado = true; }, { passive: true });
    });
    ['mouseleave', 'focusout', 'touchend'].forEach(function (ev) {
      pista.addEventListener(ev, function () { pausado = false; }, { passive: true });
    });

    var st;
    pista.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () {
        var centro = pista.scrollLeft + pista.clientWidth / 2, cerca = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var c = s.offsetLeft - pista.offsetLeft + s.offsetWidth / 2;
          if (Math.abs(c - centro) < min) { min = Math.abs(c - centro); cerca = i; }
        });
        if (cerca !== actual) { actual = cerca; pintar(); }
      }, 120);
    }, { passive: true });

    pintar();
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) arrancar();
  }

  function iniciar() {
    SECCIONES.forEach(function (frag) {
      var nodos = document.querySelectorAll('[id*="' + frag + '"]');
      for (var i = 0; i < nodos.length; i++) armar(nodos[i]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', iniciar);
})();

/* ============================================================
   ETIQUETA "ONLINE" / "PRESENCIAL" en las tarjetas de curso
   Se deduce del título del producto. Solo agrega una etiqueta
   visual: no toca precios, formularios ni el carrito.
   ============================================================ */
(function () {
  'use strict';

  function etiquetar() {
    document.querySelectorAll('product-card, .product-card').forEach(function (card) {
      if (card.dataset.mcEtiqueta === 'listo') return;

      var titulo = (card.textContent || '').toLowerCase();
      var texto = null;
      if (titulo.indexOf('online') !== -1) texto = 'Online';
      else if (titulo.indexOf('presencial') !== -1) texto = 'Presencial';
      if (!texto) { card.dataset.mcEtiqueta = 'listo'; return; }

      var destino = card.querySelector('.group-block-content') || card.querySelector('.product-grid__card');
      if (!destino) return;

      var span = document.createElement('span');
      span.className = 'mc-etiqueta';
      span.textContent = texto;
      destino.appendChild(span);
      card.dataset.mcEtiqueta = 'listo';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', etiquetar);
  } else {
    etiquetar();
  }
  document.addEventListener('shopify:section:load', etiquetar);
})();


/* ============================================================
   ANIMACIONES AL HACER SCROLL  ·  a prueba de fallos
   ------------------------------------------------------------
   Las secciones aparecen suavemente al entrar en pantalla.
   Solo opacidad y desplazamiento: no mueve el layout.

   TRES CAPAS DE SEGURIDAD, para que nunca quede contenido
   invisible:
   1. La clase "mc-anim" la agrega este script al <html>. Si el
      JS no corre, el CSS no oculta nada.
   2. Además del IntersectionObserver hay un listener de scroll
      que revela lo que entra en pantalla. Si el observador
      falla (pestaña en segundo plano, navegador antiguo), el
      scroll igual funciona.
   3. Si a los 5 segundos no se reveló NADA, se quita "mc-anim"
      del <html> y la página vuelve a mostrarse sin animación.
   ============================================================ */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var pendientes = [];

  function revelar(el) {
    el.classList.add('mc-in');
    var i = pendientes.indexOf(el);
    if (i > -1) pendientes.splice(i, 1);
  }

  function revisarVisibles() {
    var alto = window.innerHeight;
    for (var i = pendientes.length - 1; i >= 0; i--) {
      var r = pendientes[i].getBoundingClientRect();
      if (r.top < alto * 0.92 && r.bottom > 0) revelar(pendientes[i]);
    }
  }

  var pendienteFrame = false;
  function alHacerScroll() {
    if (pendienteFrame) return;
    pendienteFrame = true;
    requestAnimationFrame(function () {
      pendienteFrame = false;
      revisarVisibles();
    });
  }

  function preparar() {
    root.classList.add('mc-anim');

    var secciones = document.querySelectorAll('#MainContent > .shopify-section');
    for (var i = 0; i < secciones.length; i++) {
      if (i === 0) continue;                 // el hero ya está a la vista
      var s = secciones[i];
      if (s.dataset.mcAnim) continue;
      s.dataset.mcAnim = '1';

      var hijos = s.querySelectorAll(
        '.section-content-wrapper > .group-block, .resource-list__item'
      );
      if (hijos.length > 1 && hijos.length <= 12) {
        for (var j = 0; j < hijos.length; j++) {
          hijos[j].classList.add('mc-reveal');
          hijos[j].style.setProperty('--mc-delay', (j * 70) + 'ms');
          pendientes.push(hijos[j]);
        }
      } else {
        s.classList.add('mc-reveal');
        pendientes.push(s);
      }
    }

    // Capa 1: observador (eficiente)
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) { revelar(e.target); obs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      pendientes.slice().forEach(function (el) { obs.observe(el); });
    }

    // Capa 2: scroll (siempre funciona)
    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    revisarVisibles();
    setTimeout(revisarVisibles, 400);

    // Capa 3: si nada se reveló, se desactiva la animación completa
    setTimeout(function () {
      if (!document.querySelector('.mc-reveal.mc-in')) {
        root.classList.remove('mc-anim');
        window.removeEventListener('scroll', alHacerScroll);
      }
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparar);
  } else {
    preparar();
  }
  document.addEventListener('shopify:section:load', preparar);
})();



/* ============================================================
   MASTER CERAMISTA — PÁGINA DE CURSO
   Pegar AL FINAL de assets/mc-artesanal.js
   ------------------------------------------------------------
   Qué hace: los contenidos del curso vienen escritos como UN
   solo párrafo con saltos de línea ("1. ... <br><br> 2. ...").
   Por eso se leen como un Word. Este bloque los separa en
   ítems visuales SIN cambiar ni una letra del texto.

   No toca: carrito, checkout, formularios, variantes, precios
   ni la app de cursos. Solo trabaja dentro de
   .product-details .details-content
   ============================================================ */
(function () {
  'use strict';

  var PROHIBIDO = 'form, input, select, textarea, button, iframe, video, product-form, .quantity-selector';

  /* Quita el "1." inicial del texto (el número lo vuelve a poner el CSS) */
  function quitarNumero(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode())) {
      if (!n.textContent.trim()) continue;
      var m = n.textContent.match(/^\s*\d+\s*[.)-]\s*/);
      if (m) { n.textContent = n.textContent.slice(m[0].length); return true; }
      return false;
    }
    return false;
  }

  /* Si el ítem empieza con un título en mayúsculas, lo resalta */
  function marcarTitulo(li) {
    var w = document.createTreeWalker(li, NodeFilter.SHOW_TEXT, null, false);
    var n;
    while ((n = w.nextNode())) { if (n.textContent.trim()) break; }
    if (!n) return;

    var m = n.textContent.match(/^\s*([^.:]{3,70}[.:])/);
    if (!m) return;
    var seg = m[1];
    var letras = seg.replace(/[^A-Za-zÁÉÍÓÚÑÜáéíóúñü]/g, '');
    if (letras.length < 3) return;
    var mayus = (seg.match(/[A-ZÁÉÍÓÚÑÜ]/g) || []).length / letras.length;
    if (mayus < 0.7) return; /* si no viene en mayúsculas, no es un título */

    var idx = n.textContent.indexOf(seg);
    n.splitText(idx + seg.length);
    var sp = document.createElement('span');
    sp.className = 'mc-pasos__t';
    n.parentNode.insertBefore(sp, n);
    sp.appendChild(n);
  }

  function esTexto(html) {
    var t = document.createElement('div');
    t.innerHTML = html;
    return t.textContent.replace(/\u00a0/g, ' ').trim().length > 1;
  }

  function convertir(p) {
    if (!p.isConnected) return;
    if (p.dataset.mcItems === 'listo') return;
    if (p.querySelector(PROHIBIDO)) { p.dataset.mcItems = 'listo'; return; }

    /* solo si los <br> son hijos directos */
    var brs = 0, i;
    for (i = 0; i < p.children.length; i++) {
      if (p.children[i].tagName === 'BR') brs++;
    }
    if (brs < 2) { p.dataset.mcItems = 'listo'; return; }

    var trozos = p.innerHTML.split(/<br\s*\/?>/i).filter(esTexto);
    if (trozos.length < 2) { p.dataset.mcItems = 'listo'; return; }

    /* ¿son ítems numerados? */
    var numerados = 0;
    for (i = 0; i < trozos.length; i++) {
      var t = document.createElement('div');
      t.innerHTML = trozos[i];
      if (/^\s*\d+\s*[.)-]\s+/.test(t.textContent)) numerados++;
    }
    var esNumerada = numerados >= Math.max(2, Math.ceil(trozos.length * 0.6));

    var lista = document.createElement(esNumerada ? 'ol' : 'ul');
    lista.className = esNumerada ? 'mc-pasos' : 'mc-lista';

    for (i = 0; i < trozos.length; i++) {
      var li = document.createElement('li');
      li.innerHTML = trozos[i];
      if (esNumerada) { quitarNumero(li); marcarTitulo(li); }
      lista.appendChild(li);
    }

    lista.dataset.mcItems = 'listo';

    /* si el bloque venía envuelto en un <p> vacío, reemplazamos el <p> */
    var objetivo = p;
    if (p.parentNode && p.parentNode.tagName === 'P' &&
        p.parentNode.textContent.trim() === p.textContent.trim()) {
      objetivo = p.parentNode;
    }
    objetivo.parentNode.replaceChild(lista, objetivo);
  }

  /* El metacampo a veces viene partido en varios párrafos: unimos las
     listas de una misma pestaña para que la numeración sea continua */
  function unir(zona) {
    var listas = zona.querySelectorAll('ol.mc-pasos');
    if (listas.length < 2) return;
    var primera = listas[0];
    for (var i = 1; i < listas.length; i++) {
      while (listas[i].firstChild) primera.appendChild(listas[i].firstChild);
      if (listas[i].parentNode) listas[i].parentNode.removeChild(listas[i]);
    }
  }

  function ordenar() {
    try {
      var zonas = document.querySelectorAll('.product-details .details-content');
      for (var i = 0; i < zonas.length; i++) {
        var ps = zonas[i].querySelectorAll('p, div, span');
        for (var j = 0; j < ps.length; j++) convertir(ps[j]);
        unir(zonas[i]);
      }
    } catch (e) { /* si algo falla, el texto original queda intacto */ }
  }

  function arrancar() {
    ordenar();
    /* rte-formatter y la app pueden pintar tarde: reintentamos */
    setTimeout(ordenar, 400);
    setTimeout(ordenar, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', ordenar);
})();

/* ============================================================
   MASTER CERAMISTA — PARCHE 2 (observaciones de Katja)
   ------------------------------------------------------------
   1) La numeración queda SOLO en la pestaña "Contenidos".
      En Metodología, Al finalizar y Materiales el número se
      cambia por un círculo con visto.
   2) Marca cada etiqueta Online / Presencial para que el CSS
      pueda pintarlas de distinto color.

   No toca carrito, checkout, formularios ni la app de cursos.
   ============================================================ */
(function () {
  'use strict';

  function titulo(det) {
    var s = det.querySelector('summary');
    return s ? (s.textContent || '').toLowerCase() : '';
  }

  function marcarChecks() {
    try {
      var listas = document.querySelectorAll('.product-details .details-content ol.mc-pasos');
      for (var i = 0; i < listas.length; i++) {
        var ol = listas[i];
        if (ol.dataset.mcCheck === 'listo') continue;

        var det = ol.closest('details');
        var t = det ? titulo(det) : '';

        /* "Contenidos" conserva los números */
        if (t.indexOf('contenido') !== -1) { ol.dataset.mcCheck = 'listo'; continue; }

        ol.classList.add('mc-pasos--check');
        for (var j = 0; j < ol.children.length; j++) {
          var li = ol.children[j];
          if (li.querySelector('.mc-check')) continue;
          var v = document.createElement('span');
          v.className = 'mc-check';
          v.setAttribute('aria-hidden', 'true');
          li.insertBefore(v, li.firstChild);
        }
        ol.dataset.mcCheck = 'listo';
      }
    } catch (e) { /* si falla, quedan los números y no se rompe nada */ }
  }

  function marcarEtiquetas() {
    try {
      var et = document.querySelectorAll('.mc-etiqueta');
      for (var i = 0; i < et.length; i++) {
        var txt = (et[i].textContent || '').toLowerCase();
        et[i].setAttribute('data-mc-tipo', txt.indexOf('presencial') !== -1 ? 'presencial' : 'online');
      }
    } catch (e) { /* nada */ }
  }

  function correr() { marcarChecks(); marcarEtiquetas(); }

  function arrancar() {
    correr();
    setTimeout(correr, 600);
    setTimeout(correr, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', correr);
})();


/* ============================================================
   MASTER CERAMISTA — BLOG
   ------------------------------------------------------------
   1) Agrega un enlace real "Leer la nota" al pie de cada
      tarjeta del listado, usando el enlace del propio título.
   2) Agrega un botón "Volver al blog" al final de cada nota.

   Solo agrega enlaces de navegación. No toca carrito, checkout,
   formularios ni la app de cursos.
   ============================================================ */
(function () {
  'use strict';

  function leerLaNota() {
    var conts = document.querySelectorAll('.blog-post-card__content');
    for (var i = 0; i < conts.length; i++) {
      var c = conts[i];
      if (c.dataset.mcLeer === 'listo') continue;
      c.dataset.mcLeer = 'listo';

      var enlace = c.querySelector('a[href]');
      if (!enlace) {
        var card = c.closest('.blog-post-card');
        enlace = card ? card.querySelector('a[href]') : null;
      }
      if (!enlace) continue;

      var a = document.createElement('a');
      a.className = 'mc-leer';
      a.href = enlace.getAttribute('href');
      a.textContent = 'Leer la nota';
      c.appendChild(a);
    }
  }

  function volverAlBlog() {
    var main = document.querySelector('main[data-template="article"]');
    if (!main) return;

    var envoltorio = main.querySelector('.section-content-wrapper');
    if (!envoltorio || envoltorio.dataset.mcVolver === 'listo') return;
    envoltorio.dataset.mcVolver = 'listo';

    /* de /blogs/noticias/mi-nota  ->  /blogs/noticias */
    var partes = window.location.pathname.split('/').filter(Boolean);
    var idx = partes.indexOf('blogs');
    if (idx === -1 || !partes[idx + 1]) return;
    var destino = '/' + partes.slice(0, idx + 2).join('/');

    var caja = document.createElement('div');
    caja.className = 'mc-volver-caja';

    var a = document.createElement('a');
    a.className = 'mc-volver';
    a.href = destino;
    a.textContent = 'Volver al blog';

    caja.appendChild(a);
    envoltorio.appendChild(caja);
  }

  function correr() {
    try { leerLaNota(); } catch (e) { /* nada */ }
    try { volverAlBlog(); } catch (e) { /* nada */ }
  }

  function arrancar() {
    correr();
    setTimeout(correr, 500);
    setTimeout(correr, 1600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', correr);
})();


/* ============================================================
   MASTER CERAMISTA — BARRA DE AVANCE EN LA NOTA
   ------------------------------------------------------------
   Línea fina arriba que indica cuánto queda por leer. Solo
   aparece en las notas del blog. Si algo falla, no se dibuja
   y la página sigue igual.
   ============================================================ */
(function () {
  'use strict';

  function preparar() {
    try {
      var main = document.querySelector('main[data-template="article"]');
      if (!main || document.querySelector('.mc-avance')) return;

      var cuerpo = main.querySelector('.blog-post-content');
      if (!cuerpo) return;

      var caja = document.createElement('div');
      caja.className = 'mc-avance';
      var barra = document.createElement('div');
      barra.className = 'mc-avance__barra';
      caja.appendChild(barra);
      document.body.appendChild(caja);

      function pintar() {
        var r = cuerpo.getBoundingClientRect();
        var alto = r.height - window.innerHeight;
        var avance = alto > 0 ? (-r.top) / alto : 0;
        if (avance < 0) avance = 0;
        if (avance > 1) avance = 1;
        barra.style.transform = 'scaleX(' + avance + ')';
      }

      window.addEventListener('scroll', pintar, { passive: true });
      window.addEventListener('resize', pintar, { passive: true });
      pintar();
    } catch (e) { /* nada */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparar);
  } else {
    preparar();
  }
})();


/* ============================================================
   MASTER CERAMISTA — LA NOTA DEL BLOG EN DOS COLUMNAS
   ------------------------------------------------------------
   La nota venía como un solo chorro de párrafos: 41 párrafos
   seguidos, sin un solo título de verdad (los títulos estaban
   escritos como párrafos en mayúsculas) y con las fotos
   empujando la página hacia abajo.

   Este bloque:
     1. Detecta los títulos en mayúsculas y parte la nota en
        secciones.
     2. Arma cada sección en dos columnas, como un diario.
     3. Mete las fotos dentro de la columna y marca los pies
        de foto.
     4. Devuelve a texto normal los precios que la app de
        moneda convertía en un bloque flex de 756px, que era
        lo que rompía los párrafos en dos columnas chuecas.

   NO cambia ni una palabra del texto. Si algo falla, la nota
   queda tal como venía. No toca carrito, checkout, formularios
   ni la app de cursos.
   ============================================================ */
(function () {
  'use strict';

  function limpio(el) {
    return (el.textContent || '').replace(/ /g, ' ').trim();
  }

  function tieneFoto(el) {
    return !!el.querySelector('img');
  }

  function estaVacio(el) {
    return !limpio(el) && !tieneFoto(el);
  }

  /* Un título es un párrafo corto escrito mayormente en mayúsculas */
  function esTitulo(el) {
    var t = limpio(el);
    if (!t || t.length > 140 || tieneFoto(el)) return false;
    var letras = t.replace(/[^A-Za-zÁÉÍÓÚÑÜáéíóúñü]/g, '');
    if (letras.length < 6) return false;
    var mayus = (t.match(/[A-ZÁÉÍÓÚÑÜ]/g) || []).length;
    return mayus / letras.length > 0.6;
  }

  function arreglarMoneda(raiz) {
    var sel = '.currency-converter-wrapper-amount-box, .currency-converter-amount-box, .currency-converter-amount';
    var cajas = raiz.querySelectorAll(sel);
    for (var i = 0; i < cajas.length; i++) {
      cajas[i].style.setProperty('display', 'inline', 'important');
      cajas[i].style.setProperty('width', 'auto', 'important');
      cajas[i].style.setProperty('height', 'auto', 'important');
    }
  }

  function armar() {
    try {
      var raiz = document.querySelector('main[data-template="article"] .blog-post-content');
      if (!raiz) return;

      arreglarMoneda(raiz);

      var rte = raiz.querySelector('rte-formatter') || raiz;
      if (rte.dataset.mcNota === 'listo') return;

      var hijos = Array.prototype.slice.call(rte.children);
      if (hijos.length < 4) return;          /* nota muy corta: se deja como está */
      rte.dataset.mcNota = 'listo';

      var frag = document.createDocumentFragment();
      var bloque = null, columnas = null, veniaDeFoto = false;

      function nuevoBloque() {
        bloque = document.createElement('section');
        bloque.className = 'mc-art-bloque';
        columnas = null;
        frag.appendChild(bloque);
      }

      function cols() {
        if (!columnas) {
          columnas = document.createElement('div');
          columnas.className = 'mc-art-cols';
          bloque.appendChild(columnas);
        }
        return columnas;
      }

      nuevoBloque();

      for (var i = 0; i < hijos.length; i++) {
        var el = hijos[i];

        if (estaVacio(el)) { el.remove(); continue; }

        if (esTitulo(el)) {
          nuevoBloque();
          el.classList.add('mc-art-h');
          bloque.appendChild(el);
          veniaDeFoto = false;
          continue;
        }

        if (tieneFoto(el)) {
          el.classList.add('mc-art-foto');
          cols().appendChild(el);
          veniaDeFoto = true;
          continue;
        }

        if (veniaDeFoto && limpio(el).length < 200) {
          el.classList.add('mc-art-pie');
          cols().appendChild(el);
          veniaDeFoto = false;
          continue;
        }

        veniaDeFoto = false;
        cols().appendChild(el);
      }

      rte.innerHTML = '';
      rte.appendChild(frag);
      arreglarMoneda(raiz);
    } catch (e) { /* si algo falla, la nota queda como venía */ }
  }

  function arrancar() {
    armar();
    setTimeout(armar, 700);
    setTimeout(armar, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();